export const auctionsEndpoints = {
  getRequestAuction: { method: 'get', path: '/request-auction/{requestId}' },
  createAuctionLots: { method: 'post', path: '/{auctionId}/lots' },
  getAuctionLot: { method: 'get', path: '/{auctionId}/lots/{lotId}' },
  getAuction: { method: 'get', path: '/{auctionId}' },
  launchAuction: { method: 'post', path: '/{auctionId}/launch' },
  updateAuctionSettings: { method: 'post', path: '/{auctionId}/settings' },
  updateAuctionState: { method: 'post', path: '/{auctionId}/update-state' },
  listAuctionOwners: { method: 'get', path: '/{auctionId}/owners' },
  updateAuctionOwners: { method: 'post', path: '/{auctionId}/owners' },
} as const
